import strategyMapTabs from './strategy-maps-tabs-template'
import DashboardsOverview from '../dashboards/display/dashboards-overview'

var StrategyMapsOverview = DashboardsOverview.extend({
	tabsTemplate: strategyMapTabs
})

export default StrategyMapsOverview

StrategyMapsOverview.__filename__ = 'strategy-maps/strategy-maps-overview.js'
